import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiService } from "../services/apiService";

const PlayerDisplay = () => {
    const { id } = useParams();
    const [player, setPlayer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPlayer = async () => {
            try {
                const data = await apiService.post("/club/player", { id });
                if (data.success) {
                    setPlayer(data.player);
                } else {
                    setError(data.message || "Failed to fetch player");
                }
            } catch (err) {
                console.error("Error fetching player:", err);
                setError("Something went wrong. Try again later.");
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchPlayer();
        } else {
            setError("No player ID provided");
            setLoading(false);
        }
    }, [id]);

    if (loading) {
        return (
            <div style={styles.container}>
                <div style={styles.text}>Loading...</div>
            </div>
        );
    }

    if (error || !player) {
        return (
            <div style={styles.container}>
                <div style={styles.text}>{error || "Player not found"}</div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <div style={styles.playerName}>{player.name.toUpperCase()}</div>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: "black",
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        fontFamily: "sans-serif",
        position: "relative",
        overflow: "hidden",
        backgroundImage: `
            radial-gradient(white, rgba(255,255,255,.2) 2px, transparent 40px),
            radial-gradient(white, rgba(255,255,255,.15) 1px, transparent 30px),
            radial-gradient(white, rgba(255,255,255,.1) 2px, transparent 40px),
            radial-gradient(rgba(255,255,255,.4), rgba(255,255,255,.1) 2px, transparent 30px)
        `,
        backgroundSize: "550px 550px, 350px 350px, 250px 250px, 150px 150px",
        backgroundPosition: "0 0, 40px 60px, 130px 270px, 70px 100px",
    },
    playerLabel: {
        fontSize: "4rem",
        fontWeight: "bold",
        letterSpacing: "0.1em",
    },
    playerName: {
        fontSize: "8rem",
        fontWeight: "bold",
        letterSpacing: "0.2em",
        textAlign: 'center'
    },
};

export default PlayerDisplay;